import { Email } from '@/config/types';
import { apiSendEmailConfig } from './api-config';

const bodyEmailTemplate = `
  <div style="width:600px;">
    <p style="font-family: Arial, Helvetica, sans-serif; font-size: 15px;">Prezado,</p>
    <p style="font-family: Arial, Helvetica, sans-serif; font-size: 15px;">Segue anexo o documento _document_ referente ao território _territory_.</p>
    <p style="font-family: Arial, Helvetica, sans-serif; font-size: 15px;">Atenciosamente,</p>
    <p style="font-family: Arial, Helvetica, sans-serif; font-size: 15px;">${process.env.VUE_APP_TITLE}.</p>
    <p style="font-family: Arial, Helvetica, sans-serif; font-size: 12px; margin-top: 40px;">Por favor, não responda a este e-mail, já que ele é enviado automaticamente e não podemos ver as respostas.</p>
  </div>
`;

export default async function ({
  user: { email, iamkey }, title, attachmentUrl, body: { document, territory },
}: Email) {
  const payload = [
    {
      ContactList: [
        {
          CdContact: 0,
          StContact: email,
          StType: 'EMAIL',
          FkType: 0,
        },
      ],
      Message: null,
      Title: title,
      Html: bodyEmailTemplate
        .replace(/_document_/i, document)
        .replace(/_territory_/i, territory),
      AttachmentUrl: attachmentUrl,
    },
  ];

  const apiResponse = apiSendEmailConfig
    .post(
      '',
      payload,
      {
        params: {
          IAMKEY: iamkey,
        },
      },
    )
    .then((response) => response)
    .catch((error) => error);

  return apiResponse;
}
